import { render, staticRenderFns } from "./BookFinishCard.vue?vue&type=template&id=3a622846"
import script from "./BookFinishCard.vue?vue&type=script&lang=js"
export * from "./BookFinishCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports